import {Title} from '@mantine/core';

import {UserLimits} from '../user/UserLimits';
import useTranslation from 'src/i18next.config';

export function AccountPage() {
    const {t} = useTranslation();

    return (
        <div style={{maxWidth: 1000, margin: 'auto', padding: '1rem'}}>
            <Title order={2} mb="md">{t('usageAndLimits')}</Title>
            <UserLimits />
        </div>
    );
}
